'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getRowClassName;

var _tinycolor = require('tinycolor2');

var _tinycolor2 = _interopRequireDefault(_tinycolor);

var _themer = require('../../../../themer');

var _memoizeClassName = require('../utils/memoizeClassName');

var _memoizeClassName2 = _interopRequireDefault(_memoizeClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRowClassName(_ref) {
  var scales = _ref.scales,
      palette = _ref.palette;

  var Appearances = {};

  Appearances.default = _themer.Themer.createRowAppearance({
    base: {},

    hover: {
      backgroundColor: scales.neutral.N1A
    },

    focus: {
      backgroundColor: scales.primary.P1A
    },

    active: {
      backgroundColor: scales.primary.P2A
    },

    current: {}
  });

  Appearances.danger = _themer.Themer.createRowAppearance({
    base: {
      backgroundColor: palette.red.lightest
    },

    hover: {
      backgroundColor: (0, _tinycolor2.default)(palette.red.lightest).darken(1).toString()
    },

    focus: {
      backgroundColor: (0, _tinycolor2.default)(palette.red.lightest).darken(1.5).toString()
    },

    active: {
      backgroundColor: (0, _tinycolor2.default)(palette.red.lightest).darken(2.2).toString()
    },

    current: {}
  });

  Appearances.warning = _themer.Themer.createRowAppearance({
    base: {
      backgroundColor: palette.orange.lightest
    },

    hover: {
      backgroundColor: (0, _tinycolor2.default)(palette.orange.lightest).darken(1).toString()
    },

    focus: {
      backgroundColor: (0, _tinycolor2.default)(palette.orange.lightest).darken(1.5).toString()
    },

    active: {
      backgroundColor: (0, _tinycolor2.default)(palette.orange.lightest).darken(2.5).toString()
    },

    current: {}
  });

  Appearances.success = _themer.Themer.createRowAppearance({
    base: {
      backgroundColor: palette.green.lightest
    },

    hover: {
      backgroundColor: (0, _tinycolor2.default)(palette.green.lightest).darken(1).toString()
    },

    focus: {
      backgroundColor: (0, _tinycolor2.default)(palette.green.lightest).darken(2).toString()
    },

    active: {
      backgroundColor: (0, _tinycolor2.default)(palette.green.lightest).darken(3).toString()
    },

    current: {}
  });

  /**
   * Get the appearance of a `Row`.
   * @param {string} appearance — only one default appearance.
   * @param {string} intent - none, info, success, warning, danger.
   * @return {string} the appearance object.
   */
  var getRowAppearance = function getRowAppearance(appearance, intent) {
    switch (intent) {
      case 'danger':
        return Appearances.danger;
      case 'warning':
        return Appearances.warning;
      case 'success':
        return Appearances.success;
      case 'none':
      default:
        return Appearances.default;
    }
  };

  /**
   * Get the className of a `Row`.
   * @param {string} appearance
   * @return {string} the appearance class name.
   */
  return (0, _memoizeClassName2.default)(getRowAppearance);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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